<template>
	<div
		class="modal"
		:class="{ show: upgradeAd }"
		v-if="SubscriptionHelper.isFreeAccount() && upgradeAd">
		<div class="modal-dialog">
			<div class="modal-content shadow-lg rounded-4 bg-light">
				<div class="modal-body p-4 text-center">
					<h3 class="fw-bold mb-2">Upgrade to Plus</h3>
					<p class="text-muted mb-4">Unlock all plus features</p>
					<ul class="list-unstyled text-start small mb-4">
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>No ads
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i
							>Everything in Basic
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Quick
							Entry by Duplicating Meals
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Capture
							and Consider Meal Leftovers
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i
							>Allergy-free Alternatives (with Equipment, Ingredients,
							Instructions)
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Weekly
							Meal Plans based on Goals & Restrictions
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Recipes
							for Meals in Meal Plan
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Track
							Weight Measurements
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Track
							Blood Sugar
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Grocery
							List
						</li>
						<li class="mb-2">
							<i class="bi bi-check-circle-fill text-success me-2"></i>Reminders
							to Measure Blood Sugar After Meal
						</li>
						<li>
							<i class="bi bi-check-circle-fill text-success me-2"></i>Add
							Member to Profile
						</li>
					</ul>
					<button
						class="btn btn-lg btn-danger fw-bold w-100 pulsate-btn mb-3"
						@click="upgrade">
						<span class="fire-text">Upgrade Now!</span>
					</button>
					<button class="btn btn-outline-secondary w-100" @click="emitClose">
						No Thanks
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { useRouter } from "vue-router"
	import { upgradeAd, showAd } from "@/utils/adBus"
	import * as SubscriptionHelper from "@/utils/subscriptionHelper"

	const emit = defineEmits(["close"])

	const router = useRouter()

	function emitClose() {
		upgradeAd.value = false
		showAd.value = false
		emit("close")
	}

	function upgrade() {
		router.push({ name: "subscription" })
		emitClose()
	}
</script>

<style scoped>
	.modal {
		display: none;
		position: fixed;
		z-index: 6000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		outline: 0;
		background-color: rgba(0, 0, 0, 0.6);
	}

	.modal.show {
		display: block;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.modal-dialog {
		position: relative;
		width: auto;
		margin: 1.75rem;
		pointer-events: none;
	}

	@media (min-width: 576px) {
		.modal-dialog {
			max-width: 450px;
			margin: 1.75rem auto;
		}
	}

	.modal-content {
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		pointer-events: auto;
		background-color: #fff8e1;
		border-radius: 0.3rem;
		outline: 0;
	}

	.pulsate-btn {
		animation: pulsate 1.5s infinite alternate;
		box-shadow: 0 0 10px #ff3300, 0 0 20px #ff6600;
		background: linear-gradient(to bottom, #ff3300, #ff6600);
		border: none;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
	}

	.pulsate-btn:hover {
		transform: scale(1.05);
		box-shadow: 0 0 15px #ff3300, 0 0 30px #ff6600;
	}

	.fire-text {
		position: relative;
		display: inline-block;
		font-weight: bold;
		color: white;
		text-shadow: 0 -1px 2px #fff, 0 -2px 10px #ff0, 0 -10px 20px #ff8000,
			0 -18px 40px #f00;
	}

	@keyframes pulsate {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(1.05);
		}
	}
</style>
